import {http} from '@/http'

export default {
  saveRecord(data) {
    return http.post('/attendance/record', data)
  },
  getRecord(employeeId, companyId, date) {
    return http.get(`/attendance/record/${employeeId}/${companyId}/${date}`)
  },
  getMonthRecords(employeeId, year, month, companyId) {
    const query = companyId ? `?companyId=${companyId}` : ''
    return http.get(`/attendance/month/${employeeId}/${year}/${month}${query}`)
  },
  getMonthGrid(data) {
    return http.post('/attendance/grid', data)
  },
  getSummary(data) {
    return http.post('/attendance/summary', data)
  },
  bulkSave(data) {
    return http.post('/attendance/bulk', data)
  },
  downloadSummaryXlsx(data) {
    return http.post('/attendance/summary/xlsx', data, {responseType: 'blob'})
  },
  // Exportación plana de la grilla: una fila por marcación persistida (respeta empresa/área/mes).
  downloadExport(year, month, companyId, areaId, search) {
    let query = `?year=${year}&month=${month}`
    if (companyId) query += `&companyId=${companyId}`
    if (areaId) query += `&areaId=${areaId}`
    if (search) query += `&search=${encodeURIComponent(search)}`
    return http.get(`/attendance/export${query}`, {responseType: 'blob'})
  },
  downloadTemplate(data) {
    return http.post('/attendance/template/xlsx', data, {responseType: 'blob'})
  },
  uploadExcel(formData, year, month) {
    return http.post(`/attendance/upload?year=${year}&month=${month}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
  // Wizard: validar (sin persistir) → confirmar filas válidas.
  validateUpload(formData, year, month) {
    return http.post(`/attendance/upload/validate?year=${year}&month=${month}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
  confirmUpload(rows) {
    return http.post('/attendance/upload/confirm', rows)
  },
  getAlerts(employeeId, companyId) {
    const params = companyId ? `?employeeId=${employeeId}&companyId=${companyId}` : `?employeeId=${employeeId}`
    return http.get(`/attendance/alerts${params}`)
  },
  propagateHoliday(data) {
    return http.post('/attendance/holiday/propagate', data)
  },
}
